import { Injectable } from '@angular/core';
import {
  ICisterna,
  IComando,
  ICreateCisterna,
  IDispositivo,
  IDispositivoNivelCisterna,
  IQueryParam,
  IReporte,
  IReporteNivelCisterna,
  IUpdateCisterna,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from 'src/environments/environment';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class CisternasService {
  constructor(private http: HttpService) {}

  // Cisternas
  public getCisterna(id: string): Observable<ICisterna> {
    return this.http.get(`${api}/cisternas/${id}`);
  }
  public getCisternas(queryParams?: IQueryParam): Observable<{
    data: ICisterna[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/cisternas`, { params });
  }
  public createCisterna(data: ICreateCisterna): Observable<ICisterna> {
    return this.http.post(`${api}/cisternas`, data);
  }
  public updateCisterna(
    id: string,
    data: IUpdateCisterna,
  ): Observable<ICisterna> {
    return this.http.put(`${api}/cisternas/${id}`, data);
  }
  public deleteCisterna(id: string): Observable<ICisterna> {
    return this.http.delete(`${api}/cisternas/${id}`);
  }

  // Comandos
  public cambiarRele1(deveui: string, encendido: boolean) {
    return this.http.post(`${api}/comandos/cisternas/cambiarRele1`, {
      data: { deveui, encendido },
    });
  }
  public cambiarRele2(deveui: string, encendido: boolean) {
    return this.http.post(`${api}/comandos/cisternas/cambiarRele2`, {
      data: { deveui, encendido },
    });
  }
  public presionarRele1(deveui: string, encendido: boolean) {
    return this.http.post(`${api}/comandos/cisternas/presionarRele1`, {
      data: { deveui, encendido },
    });
  }
  public presionarRele2(deveui: string, encendido: boolean) {
    return this.http.post(`${api}/comandos/cisternas/presionarRele2`, {
      data: { deveui, encendido },
    });
  }

  // Helpers

  public estadoDispositivo(dato: IDispositivo) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.fechaUltimaComunicacion
      ? new Date(dato.fechaUltimaComunicacion)
      : null;
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }

  public nivelCalculado(
    dispostivo: IDispositivo,
    cisterna?: ICisterna,
    reporte?: IReporte,
  ) {
    const configDisp = dispostivo.config as IDispositivoNivelCisterna;
    const dataReporte = (reporte?.reporte ||
      dispostivo.ultimoReporte?.reporte) as IReporteNivelCisterna;

    const alturaDeInstalacion = configDisp?.nivelDeInstalacion || 0;
    const alturaCisterna = cisterna?.alturaMm || 0;
    const medicion = dataReporte?.distancia || 0;

    const altura = alturaDeInstalacion + alturaCisterna - medicion;

    return altura;
  }

  public nivelPorcentaje(
    dispostivo: IDispositivo,
    cisterna?: ICisterna,
    reporte?: IReporte,
  ) {
    const alturaCisterna = cisterna?.alturaMm || 0;

    const altura = this.nivelCalculado(dispostivo, cisterna, reporte);
    const nivel = (altura * 100) / alturaCisterna;

    return Math.trunc(nivel);
  }

  public unidad(valor: number, unidad?: 'mm' | 'cm' | 'm') {
    if (unidad === 'cm') {
      return `${(valor * 0.1).toFixed(2)} cm.`;
    } else if (unidad === 'm') {
      return `${(valor * 0.001).toFixed(2)} m.`;
    } else {
      return `${valor} mm.`;
    }
  }

  public volumenCalculado(
    dispostivo: IDispositivo,
    cisterna?: ICisterna,
    reporte?: IReporte,
  ) {
    const alturaCisterna = cisterna?.alturaMm || 0;
    const volumenCisterna = cisterna?.volumenM3 || 0;

    const altura = this.nivelCalculado(dispostivo, cisterna, reporte);

    const volumen = (volumenCisterna * altura) / alturaCisterna;

    return +volumen.toFixed(2);
  }

  public apagar(deveui: string) {
    return this.http.post(`${apiBase}/comandos/cisternas/presionarRele2`, {
      deveui,
      encendido: true,
    });
  }

  public encender(deveui: string) {
    return this.http.post(`${apiBase}/comandos/cisternas/presionarRele1`, {
      deveui,
      encendido: true,
    });
  }

  public delComando(id: string): Observable<IComando> {
    return this.http.delete(`${api}/comandos/${id}`);
  }
}
